import { Money } from '~/types/money';
import { absMoney, compareMoney, newMoney, maybeSumMoney } from '~/utils/money';

export const areEntriesBalanced = (
  entries: {
    dare: Money | null;
    avere: Money | null;
  }[],
): boolean => {
  const totalDare = entries.reduce((acc, entry) => {
    if (entry.dare?.amount) {
      return maybeSumMoney(acc, entry.dare) ?? acc;
    }
    return acc;
  }, newMoney(0));

  const totalAvere = entries.reduce((acc, entry) => {
    if (entry.avere?.amount) {
      return maybeSumMoney(acc, entry.avere) ?? acc;
    }
    return acc;
  }, newMoney(0));

  return compareMoney(absMoney(totalDare), absMoney(totalAvere)) === 0;
};
